// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1KTxZ{margin-top:6px;margin-bottom:12px}._36KqD{margin:16px 8px}._36KqD div{border-radius:18px}._1XVdN{margin-bottom:2rem}._1XVdN div{margin-bottom:8px}.kS0fL{margin:16px 8px 8px;display:flex;justify-content:space-between;align-items:center}.kS0fL .aO33j{flex-grow:1;padding:0 16px}.kS0fL .aO33j div{margin-bottom:6px}._3Vp16{margin:16px 8px}._3Vp16 div:last-child{margin-top:8px}._2xs3h{display:flex;justify-content:space-around}._2xs3h ._1K4cL{display:flex;align-items:center;margin:16px 0}._2xs3h ._3azuH{margin-left:8px}._2xs3h ._3azuH div:last-child{margin-top:6px}\n", ""]);
// Exports
exports.locals = {
	"skeleton": "_1KTxZ",
	"button": "_36KqD",
	"paragraph": "_1XVdN",
	"greeting": "kS0fL",
	"greetingText": "aO33j",
	"input": "_3Vp16",
	"usps": "_2xs3h",
	"usp": "_1K4cL",
	"uspsText": "_3azuH"
};
module.exports = exports;
